var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import PropTypes from 'prop-types';
import React from 'react';

var withClozeHandler = function withClozeHandler(WrappedComponent) {
  var HandleClozeProvider = function (_React$Component) {
    _inherits(HandleClozeProvider, _React$Component);

    function HandleClozeProvider(props) {
      _classCallCheck(this, HandleClozeProvider);

      var _this = _possibleConstructorReturn(this, (HandleClozeProvider.__proto__ || Object.getPrototypeOf(HandleClozeProvider)).call(this, props));

      _this.getChildContext = function () {
        return {
          addToClozeAnswers: _this.addToClozeAnswers,
          getClozeAnswers: _this.state.selectedAnswers,
          setInputId: _this.setInputId,
          getInputId: _this.state.inputId
        };
      };

      _this.setInputId = function (value) {
        _this.setState({
          inputId: value
        });
      };

      _this.addToClozeAnswers = function () {
        var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var selectedAnswers = _this.state.selectedAnswers;

        if (value) {
          var idIndex = selectedAnswers.findIndex(function (answer) {
            return answer.id.split(':')[0] === value.id.split(':')[0];
          }); // get the first part of answer id to get the cloze input id
          idIndex < 0 ? selectedAnswers.push(value) : selectedAnswers[idIndex] = value;
        } else {
          _this.setState({
            selectedAnswers: [],
            inputId: 'c1'
          });
        }
      };

      _this.state = {
        inputId: 'c1',
        selectedAnswers: []
      };
      return _this;
    }

    _createClass(HandleClozeProvider, [{
      key: 'render',
      value: function render() {
        var _state = this.state,
            inputId = _state.inputId,
            selectedAnswers = _state.selectedAnswers;

        return React.createElement(WrappedComponent, Object.assign({
          getInputId: inputId,
          setInputId: this.setInputId,
          addToClozeAnswers: this.addToClozeAnswers,
          getClozeAnswers: selectedAnswers
        }, this.props));
      }
    }]);

    return HandleClozeProvider;
  }(React.Component);

  HandleClozeProvider.childContextTypes = {
    addToClozeAnswers: PropTypes.func,
    getClozeAnswers: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      text: PropTypes.string,
      type: PropTypes.string
    })),
    setInputId: PropTypes.func,
    getInputId: PropTypes.string
  };

  return HandleClozeProvider;
};

export default withClozeHandler;